import { useState } from "preact/hooks";
import { whenShown, whenText, whenToggleLabel, type WhenMode } from "../../shared/when.ts";

let nextId = 0;

/**
 * A time on the task screen's meta line that a tap reads out in full (shared/when.ts): an open
 * task's "7 h ago" becomes "Sun, Oct 4, 8:13 PM · 7 h ago", a done task's day and time gains its
 * "3 d ago", and a second tap goes back. It is an inline span in the line's sentence, not a box:
 * the time is one unbreakable unit (whenText) and the line wraps like prose after its dots. The
 * vertical padding of an inline element does not change the line's layout, so it makes the 44px
 * target without moving a thing (owner, 2026-10-05, on a three-line column: "This looks like trash").
 */
export function WhenButton({ iso, now, rest }: { iso: string | null | undefined; now: number; rest: Exclude<WhenMode, "full"> }) {
  const [open, setOpen] = useState(false);
  const [id] = useState(() => `detail-when-${++nextId}`);
  if (!iso) return null;
  const toggle = () => setOpen((o) => !o);
  return (
    <span
      role="button"
      tabIndex={0}
      class="detail-when"
      aria-label={whenToggleLabel(rest, open)}
      aria-describedby={id}
      onClick={toggle}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          toggle();
        }
      }}
    >
      <span id={id}>{whenText(iso, now, whenShown(rest, open))}</span>
    </span>
  );
}
